/// <amd-module name="VSS/Features/Conduct/RestClient/ContentViolation" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\cloud.webapi\httpclients\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as ContentViolation from "../Contracts/ContentViolation";

export interface IContentViolationRestClient extends IVssRestClient {
    /**
     * Enables to report an offensive content to Content Validation Service (AVERT).
     * 
     * @param violationReport - Details about the offensive content like type, url, etc.
     */
    reportAbuse(violationReport: ContentViolation.ContentViolationReport): Promise<ContentViolation.ContentViolationReportResult>;
}

class ContentViolationRestClient extends RestClientBase implements IContentViolationRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Enables to report an offensive content to Content Validation Service (AVERT).
     * 
     * @param violationReport - Details about the offensive content like type, url, etc.
     */
    public async reportAbuse(
        violationReport: ContentViolation.ContentViolationReport
        ): Promise<ContentViolation.ContentViolationReportResult> {

        return this.beginRequest<ContentViolation.ContentViolationReportResult>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/contentViolation/reports",
            body: violationReport
        });
    }

}

export const ContentViolationClientName = "IContentViolationRestClient";

export function getContentViolationClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IContentViolationRestClient {
    return pageContext.getRestClient<IContentViolationRestClient>(ContentViolationClientName, options);
}

RestClients.add(ContentViolationClientName, { 
    factory: ContentViolationRestClient
});
